// Leaderboard — top XP earners, optional function filter.
// Read access is champion+ per the backend gate on GET /api/levels.

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, type Level } from "../lib/api";

const FUNCTIONS = ["", "Engineering", "Sales", "HR", "Finance", "Project Management", "Operations", "Other"];

export function Leaderboard() {
  const [fn, setFn] = useState("");
  const { data, isLoading, error } = useQuery<Level[]>({
    queryKey: ["levels", fn || "all"],
    queryFn: () => api.levels.list(fn || undefined),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-baseline justify-between">
        <h1 className="text-xl font-semibold">Leaderboard</h1>
        <select
          className="border rounded px-2 py-1 text-sm"
          value={fn}
          onChange={(e) => setFn(e.target.value)}
        >
          {FUNCTIONS.map((f) => <option key={f} value={f}>{f || "All functions"}</option>)}
        </select>
      </div>
      {isLoading ? <p>Loading…</p> : null}
      {error ? <p className="text-red-700 text-sm">{(error as Error).message}</p> : null}
      {data ? (
        <table className="w-full text-sm">
          <thead className="border-b border-slate-300 text-left">
            <tr>
              <th className="py-2 w-8">#</th>
              <th>Name</th>
              <th>Function</th>
              <th className="text-right">XP</th>
              <th>Level</th>
              <th className="text-right">Wins ✓</th>
            </tr>
          </thead>
          <tbody>
            {data.map((l, i) => (
              <tr key={l.user_id} className="border-b border-slate-100">
                <td className="py-1 text-slate-500">{i + 1}</td>
                <td>{l.name}</td>
                <td className="text-slate-600">{l.function}</td>
                <td className="text-right">{l.total_xp}</td>
                <td>{l.level}</td>
                <td className="text-right">{l.wins_verified}</td>
              </tr>
            ))}
            {data.length === 0 ? (
              <tr><td colSpan={6} className="py-4 text-center text-slate-500">No data yet.</td></tr>
            ) : null}
          </tbody>
        </table>
      ) : null}
    </div>
  );
}
